
import WebServiceWrapper from "./WebServiceWrapper";

export const NonMDETreatmentService = {
    LoadData,
    SaveData
};
function LoadData(patientId,userId) {
    return WebServiceWrapper.Get(`/nonMDETreatment/LoadData?patientId=${patientId}&&userId=${userId}`);
}
function SaveData(payload) {
    return WebServiceWrapper.Post("/nonMDETreatment/SaveData", payload);
}
